import { useContextCalendars } from '@rehookify/datepicker';

import { MonthView } from '../../DateRangePicker/components/MonthView';

export const CalendarMonth = () => {
    const { calendars } = useContextCalendars();

    return <MonthView calendar={calendars[0]} hasPrevious hasNext />;
};
